import { FileContent, FileContentFactory } from "../"
import { Address, AddressFactory } from "./address.model"
import { LandlordData, LandlordDataKeys } from "./landlordData.model"
import { PropertyRoom } from "./propertyRoom.model"

export interface ModifyLandlordData {
   name: string
   surname: string
   phoneNumber: string
   email: string
   oib: string
   residenceAddress: Address
   propertyRooms: PropertyRoom[]
   areaOfProperty: number
   iban: string
   swift: string
   startRentDate: Date | null
   endRentDate: Date | null
   isApartmentOfLegalEntity: boolean
   rentalPropertyAddress: Address
   monthlyRent: number
   consentForm: FileContent
   catastarKO: string
   catastarCE: string
   ownershipCertificate: FileContent
   submitted: boolean
}

export class ModifyLandlordDataFactory {
   static create(): ModifyLandlordData {
      return {
         name: "",
         surname: "",
         phoneNumber: "",
         email: "",
         oib: "",
         residenceAddress: AddressFactory.create(),
         propertyRooms: [],
         areaOfProperty: 0,
         iban: "",
         swift: "",
         startRentDate: null,
         endRentDate: null,
         isApartmentOfLegalEntity: false,
         rentalPropertyAddress: AddressFactory.create(),
         monthlyRent: 0,
         consentForm: FileContentFactory.create(),
         catastarKO: "",
         catastarCE: "",
         ownershipCertificate: FileContentFactory.create(),
         submitted: false,
      }
   }

   static from(landlordData: LandlordData): ModifyLandlordData {
      if (!landlordData) return ModifyLandlordDataFactory.create()
      return {
         name: landlordData.name,
         surname: landlordData.surname,
         phoneNumber: landlordData.phoneNumber,
         email: landlordData.email,
         oib: landlordData.oib,
         residenceAddress: landlordData.residenceAddress,
         propertyRooms: landlordData.propertyRooms,
         areaOfProperty: landlordData.areaOfProperty,
         iban: landlordData.iban,
         swift: landlordData.swift,
         startRentDate: landlordData.startRentDate ?? null,
         endRentDate: landlordData.endRentDate ?? null,
         isApartmentOfLegalEntity: landlordData.isApartmentOfLegalEntity,
         rentalPropertyAddress: landlordData.rentalPropertyAddress,
         monthlyRent: landlordData.monthlyRent,
         consentForm: FileContentFactory.fromUrl(landlordData.consentForm),
         catastarKO: landlordData.catastarKO,
         catastarCE: landlordData.catastarCE,
         ownershipCertificate: FileContentFactory.fromUrl(landlordData.ownershipCertificate),
         submitted: landlordData.submitted,
      }
   }
}

export const EmptyModifyLandlordDataErrors: { [key: string]: boolean } = {
   [LandlordDataKeys.Name]: false,
   [LandlordDataKeys.Surname]: false,
   [LandlordDataKeys.PhoneNumber]: false,
   [LandlordDataKeys.Email]: false,
   [LandlordDataKeys.OIB]: false,
   [LandlordDataKeys.ResidenceAddress]: false,
   [LandlordDataKeys.PropertyRooms]: false,
   [LandlordDataKeys.AreaOfProperty]: false,
   [LandlordDataKeys.Iban]: false,
   [LandlordDataKeys.Swift]: false,
   [LandlordDataKeys.StartRentDate]: false,
   [LandlordDataKeys.EndRentDate]: false,
   [LandlordDataKeys.IsApartmentOfLegalEntity]: false,
   [LandlordDataKeys.RentalPropertyAddress]: false,
   [LandlordDataKeys.MonthlyRent]: false,
   [LandlordDataKeys.ConsentForm]: false,
   [LandlordDataKeys.CatastarCE]: false,
   [LandlordDataKeys.CatastarKO]: false,
   [LandlordDataKeys.OwnershipCertificate]: false,
   [LandlordDataKeys.Submitted]: false,
}